import React from "react";

const CategoryLabel = (props) => {
  const backgroundColor = () => {
    if (props.code == 'nutrition_postures') {
      return '#FB5872'
    } else if (props.code == 'bolo_orientation_postures') {
      return '#58DEFB'
    } else if (props.code == 'maneuvers') {
      return '#ECFF74'
    } else if (props.code == 'iddsi') {
      return '#40FDAE'
    }
  }

  return (
    <div className={`badge badge-secondary text-uppercase`}
      style={{ color: backgroundColor(), backgroundColor: '#16181C' }}>
      {props.title}
    </div>
  );
};

export { CategoryLabel as default };
